import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelEloquaIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          d="M9.04458 17.0446C6.24204 17.0446 4 14.8026 4 12C4 9.19746 6.24204 6.95541 9.04458 6.95541H14.9554C17.758 6.95541 20 9.19746 20 12C20 14.8026 17.758 17.0446 14.9554 17.0446H9.04458ZM14.8025 15.2611C16.6369 15.2611 18.0637 13.7835 18.0637 12C18.0637 10.1656 16.586 8.73885 14.8025 8.73885H9.19745C7.36306 8.73885 5.93631 10.2166 5.93631 12C5.93631 13.7835 7.41401 15.2611 9.19745 15.2611H14.8025Z"
          fill="#C74634"
        />
      </SvgIcon>
    );
  })
);
